import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pilcrow-3H15k",
  "use": "pilcrow-3H15k-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol class=\"feather feather-list\" stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pilcrow-3H15k\"><path d=\"M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol